var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        {
          staticClass:
            "col-lg-6 col-md-6 offset-md-3 offset-lg-3 col-12 text-center p-0"
        },
        [
          _c("div", { staticClass: "card shadow-sm" }, [
            _c("div", { staticClass: "card-body" }, [
              _c("img", {
                staticClass: "img-fluid",
                attrs: { src: "/static/img/nimcap/3.png", alt: ".." }
              }),
              _vm._v(" "),
              _c("hr"),
              _vm._v(" "),
              _c("div", { staticClass: "checkbox" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.borrowerConfirmPDPA,
                      expression: "borrowerConfirmPDPA"
                    }
                  ],
                  attrs: { type: "checkbox", id: "agree", name: "agree" },
                  domProps: {
                    checked: Array.isArray(_vm.borrowerConfirmPDPA)
                      ? _vm._i(_vm.borrowerConfirmPDPA, null) > -1
                      : _vm.borrowerConfirmPDPA
                  },
                  on: {
                    change: function($event) {
                      var $$a = _vm.borrowerConfirmPDPA,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            (_vm.borrowerConfirmPDPA = $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            (_vm.borrowerConfirmPDPA = $$a
                              .slice(0, $$i)
                              .concat($$a.slice($$i + 1)))
                        }
                      } else {
                        _vm.borrowerConfirmPDPA = $$c
                      }
                    }
                  }
                }),
                _vm._v(" "),
                _vm._m(0)
              ])
            ])
          ])
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "mb-0", attrs: { for: "agree" } }, [
      _c("span"),
      _vm._v("\n                        ข้าพเจ้ายินยอม\n                      ")
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bcd0fc9a", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bcd0fc9a","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nimcap/Components/Borrower/Step2.vue
// module id = 2270
// module chunks = 0